import { render } from "./showBrokersComponent.vue?vue&type=template&id=45a0f6ba"
import script from "./showBrokersComponent.vue?vue&type=script&lang=js"
export * from "./showBrokersComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__